import { useId } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { DatePicker } from "@design-system/DatePicker/DatePicker";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { VStack } from "@design-system/VStack/VStack";
import { BulkScheduleNoun } from "./bulkScheduleRows";

interface Props {
    show: boolean;
    templateName: string;
    noun: BulkScheduleNoun;
    count: number;
    specificDate: string | null;
    onSpecificDateChange: (specificDate: string | null) => void;
    onConfirm: () => Promise<void>;
    onDismiss: () => void;
}

/** Asks once for the recognition start a Specific date policy needs across the whole selection. */
export const BulkScheduleSpecificDateModal = ({
    show,
    templateName,
    noun,
    count,
    specificDate,
    onSpecificDateChange,
    onConfirm,
    onDismiss,
}: Props) => {
    const labelId = useId();
    return (
        <ConfirmationModal
            show={show}
            title="Recognition start date"
            question={
                <VStack gap={12}>
                    <span id={labelId}>
                        {templateName} needs a recognition start date. All{" "}
                        {pluralizeWithCount(noun, count)} will start on it.
                    </span>
                    <DatePicker
                        mode="day"
                        value={specificDate ?? undefined}
                        onValueChange={(date) =>
                            onSpecificDateChange(date ?? null)
                        }
                        fieldControlProps={{ "aria-labelledby": labelId }}
                    />
                </VStack>
            }
            yes="Apply schedule"
            no="Cancel"
            confirmDisabled={!specificDate}
            onConfirm={onConfirm}
            onHide={onDismiss}
        />
    );
};
